import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { ButtonInLink } from '@hivebrite/design-system/ButtonInLink';

import AboutScreenReader from 'hb-react/frontoffice/apps/LiveFeed/components/AboutScreenReader';
import { useLandingContext } from 'hb-react/frontoffice/apps/LiveFeed/contexts/LandingContext';
import { useProjectsCustomName } from 'hb-react/frontoffice/apps/VenturesV2/hooks/useProjectsCustomName';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

import Landing from '../Landing';
import LandingContent from '../Landing/Content';

const Venture = () => {
  const { id, location, logoUrl, title, ventureContent } = useLandingContext();
  const { currentNetwork } = useDefaultAppContexts();

  const { liveFeedTitle } = useProjectsCustomName();

  const commentsEnabled =
    currentNetwork?.network_configuration?.ventures?.comments_enabled;

  return (
    <Landing title={liveFeedTitle(title)} commentsEnabled={commentsEnabled}>
      <Wrapper>
        <Box alignItems="center" mb={3}>
          {logoUrl && (
            <Box width={52} height={52} mr={4}>
              <RoundedImage src={logoUrl} alt="" />
            </Box>
          )}
          <Box display="block">
            <Box font="h4-semibold">{title}</Box>
            {location?.address && <Box mt={1}>{location?.address}</Box>}
          </Box>
        </Box>
        <LandingContent content={ventureContent} mt={4} />
        <Box mt={3}>
          <ButtonInLink
            linkProps={{
              to: Routes.venture_path(id),
            }}
          >
            {__('Find out more')}
            <AboutScreenReader name={title} />
          </ButtonInLink>
        </Box>
      </Wrapper>
    </Landing>
  );
};

export default Venture;

const Wrapper = styled(Box).attrs(() => ({
  bg: 'smoke',
  display: 'block',
  mt: 4,
  mx: { _: -4, m: 0 },
  p: 4,
  pb: 6,
}))`
  border-radius: 2px;
`;

const RoundedImage = styled.img`
  border-radius: ${({ theme }) => theme.themeVariables.globalBorderRadius}px;
`;
